import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';

export default class Edit extends Component {
    state = {
        transaction: {
            first_name: '',
            last_name: '',
            email: '',
            cellphone: '',
            payment_ref: '',
            payment_success: 0,
            shares: 0,
            total: 0,
            created_at: ''
        },
        user: {
            first_name: ''
        },
        project: {
            title: ''
        },
        group: {
            name: ''
        },
        message: '',
        errors: '',
        redirectBack: 0
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.submit = this.submit.bind(this);
        this.remove = this.remove.bind(this);
    }

    componentDidMount() {
        axios.get(API_URL+'/admin/transactions/'+this.props.match.params.id)
            .then(response => {
                console.log(response.data);
                this.setState({ 
                    transaction: {
                        first_name: response.data.first_name,
                        last_name: response.data.last_name,
                        email: response.data.email,
                        cellphone: response.data.cellphone,
                        payment_ref: response.data.payment_ref ? response.data.payment_ref : '',
                        payment_success: response.data.payment_success,
                        shares: response.data.shares,
                        total: response.data.total,
                        created_at: response.data.created_at
                    },
                    user: {
                        first_name: response.data.user ? response.data.user.first_name : '',
                    },
                    project: {
                        title: response.data.project ? response.data.project.title : ''
                    },
                    group: {
                        name: response.data.group ? response.data.group.name : ''
                    }
                });
            });
    }

    inputChange(event) {
        this.setState({ transaction: {...this.state.transaction, [event.target.name]: event.target.value }});
    }

    submit(event) {
        event.preventDefault();

        axios.put(API_URL+'/admin/transactions/'+this.props.match.params.id, {
            first_name: this.state.transaction.first_name,
            last_name: this.state.transaction.last_name,
            email: this.state.transaction.email,
            cellphone: this.state.transaction.cellphone,
            payment_ref: this.state.transaction.payment_ref,
            payment_success: this.state.transaction.payment_success,
            shares: this.state.transaction.shares,
            total: this.state.transaction.total
        })
        .then(response => {
            this.setState({ message: 'Ändringarna har sparats.' });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    remove(event) {
        event.preventDefault();

        axios.delete(API_URL+'/admin/transactions/'+this.props.match.params.id)
        .then(response => {
            this.setState({ redirectBack: true });
        })
        .catch(error => {
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }
    
    render() {
        const { transaction, user, group, project } = this.state;
        
        if (this.state.redirectBack) {
            return (
                <Redirect to="/superadmin/transactions" message="Transaktionen har tagits bort" />
            )            
        }
        
        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1 className="m-bottom-l">Redigera transaktion</h1>

                        <form onSubmit={ this.submit }>
                            <label>Förnamn</label>
                            <input type="text" name="first_name" required value={ transaction.first_name } onChange={ this.inputChange } />

                            <label>Efternamn</label>
                            <input type="text" name="last_name" required value={ transaction.last_name } onChange={ this.inputChange } />

                            <label>E-postadress</label>
                            <input type="email" name="email" required value={ transaction.email } onChange={ this.inputChange } />

                            <label>Mobilnummer</label>
                            <input type="text" name="cellphone" required value={ transaction.cellphone } onChange={ this.inputChange } />

                            <label>Referens</label>
                            <input type="text" name="payment_ref" value={ transaction.payment_ref } onChange={ this.inputChange } />

                            <label>Andelar</label>
                            <input type="number" name="shares" required value={ transaction.shares } onChange={ this.inputChange } />

                            <label>Summa</label>
                            <input type="text" name="total" required value={ transaction.total } onChange={ this.inputChange } />

                            <hr />

                            <label>Status</label>
                            <input type="text" disabled value={ `${ transaction.payment_success === 1 ? 'Genomförd' : 'Påbörjad' }` } />

                            <label>Skapad</label>
                            <input type="text" disabled value={ transaction.created_at } onChange={ this.inputChange } />

                            <label>Skapad av</label>
                            <input type="text" disabled value={ user.first_name } onChange={ this.inputChange } />

                            <label>Grupp</label>
                            <input type="text" disabled value={ group.name } onChange={ this.inputChange } />

                            <label>Projekt</label>
                            <input type="text" disabled value={ project.title } onChange={ this.inputChange } />

                            <input className="button purple m-top-l" type="submit" value="Spara" />
                        </form>

                        <div className="danger-zone">
                            <h3>Ta bort</h3>
                            <p>Obs! Detta går inte att ångra.</p>
                            <button onClick={ this.remove }>Ta bort</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Transactions/Edit.js